import { configureStore } from '@reduxjs/toolkit'

import addVehicleReducer from '../redux/addVehicleSlice/addVehicle'
import authReducer from '../redux/authSlice/authSlice'
import bookingReducer from '../redux/bookingSlice/bookingSlice'
import customerVehicleReducer from '../redux/customerVehicleSlice/customerVehicleSlice'
import ListOfServiceBookingReducer from '../redux/ListOfServiceBooking/ListOfServiceBookingSlice'
import modelReducer from '../redux/modelSlice/modelSlice'
import technicianListReducer from '../redux/technicianListSlice/technicianListSlice'
import vehicleReducer from '../redux/vehicleSlice/vehicleSlice'
import rentalVehicleReducer from '../redux/rentalSlice/rentalVehicleSlice'
import quoteReducer from '../redux/quoteSlice/quoteSlice'

export const store = configureStore({
  reducer: {
    authReducer, modelReducer, vehicleReducer, addVehicleReducer,rentalVehicleReducer, customerVehicleReducer, ListOfServiceBookingReducer, bookingReducer, technicianListReducer,quotes : quoteReducer
  }
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
